import { jsonParse } from "@/utils/common/jsonHelper/jsonHelper";
import {
  getLocalStorageItemWithExpiry,
  setLocalStorageItemWithExpiry,
} from "@/utils/common/localStorageItemHelper/localStorageItemUtills";
import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";
import { LocalStorageItemEnum } from "@/utils/enums/LocalStorageItemEnum";

import {
  type RequestHolidayInterface,
  ResponseHolidayDataClass,
} from "./holidayServiceInterface";

const isMockUpData = false;
class HolidayService {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************
  async getHolidayData(params?: RequestHolidayInterface) {
    const getLocalHolidayData = getLocalStorageItemWithExpiry(
      LocalStorageItemEnum.HOLIDAY,
    );
    if (getLocalHolidayData) {
      return jsonParse(getLocalHolidayData);
    }
    const holidayResponse: any = await apiRequest(
      this.baseUrl,
      `/holidays`,
      "GET",
    );

    const response = new ResponseHolidayDataClass(holidayResponse);
    if (response.success) {
      setLocalStorageItemWithExpiry(
        LocalStorageItemEnum.HOLIDAY,
        response,
        24 * 1000 * 60 * 60, // 1 day
      );
    }
    return response;
  }

  // ******************************************************
  // ****************** Method: POST **********************
  // ******************************************************
}

export default HolidayService;
